// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import MUIDataTable from "mui-datatables";
// COMPONENTS
import BlockUi from 'react-block-ui';
import { Spinner } from 'react-bootstrap';
// ICONS
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
//SERVICES AND HELPERS
import * as dashboardService from '../../../../services/dashboard/dashboardService';
import * as quickBookBillsAndChecksService from '../../../../services/service/quickBookBillsAndChecksService';


const QuickBooksData = (props) => {
    const { auth, jobInfo, projectNumber } = props;
    const [quickBooksData, setQuickBooksData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (auth && auth.user && Object.keys(auth.user).length > 0 &&  (auth.user.username === 'admin' || auth.user.username === 'Chip')) {
            fetchQuickBooksData();
        }
    }, [projectNumber]);

    const fetchQuickBooksData = () => {
        setLoading(true);
        quickBookBillsAndChecksService.getQuickBooksData(projectNumber || '').then(res => {
            setQuickBooksData(res);
        }).catch(err => {
            console.log('error getting quickbooks data', err)
        }).finally(() => {
            setLoading(false);
        })
    }

    const quickBooksBillAndChecksColumn = [
        {
            name: "projectNumber",
            label: "Project Number",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "amount",
            label: "Amount",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "category",
            label: "Category",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "description",
            label: "Description",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "transactionDate",
            label: "Transaction Date",
            options: {
                filter: false,
                sort: true,
                print: false,
                download: true,
                customBodyRenderLite: (dataIndex) => (
                    <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                        <p>{quickBooksData[dataIndex].transactionDate ? moment(quickBooksData[dataIndex].transactionDate).format('MM/DD/YYYY A') : '-'}</p>
                    </CustomBlock>
                )
            }
        },
        {
            name: "transactionType",
            label: "Transaction Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
    ]

    return (
        <>
            <BlockUi tag="div" blocking={loading}>
                <CustomBlock className="detail-block mt-2">
                    <div className="col-lg-12 col-xxl-12 mb-10">
                        <div className={`card card-custom card-stretch gutter-b`}>
                            <div className="card-header py-3 mb-10">
                                <div className="card-title align-items-start flex-column">
                                    <h3 className="card-label font-weight-bolder text-dark">
                                        Bills And Checks
                                    </h3>
                                </div>
                            </div>
                            <MUIDataTable
                                data={quickBooksData}
                                columns={quickBooksBillAndChecksColumn}
                                options={{
                                    rowsPerPage: 10,
                                    rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                    selectableRows: 'none',
                                    textLabels: {
                                        body: {
                                            noMatch: loading ?
                                                <Spinner animation="border" size="lg" variant="info" /> :
                                                'Sorry, no matching records found.',
                                        },
                                    }
                                }}

                            />
                        </div>
                    </div>
                </CustomBlock>
            </BlockUi>
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {
    ...alert.actions,
})(QuickBooksData)